import { useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { Button } from "@shared/components/ui/button";
import { notificationsSupported } from "@/components/layout/pass-notification";
import { useT } from "@shared/client/locale";

type Permission = NotificationPermission | "unsupported";

/**
 * Demande l'accord du navigateur pour prévenir à la fin du passage — au moment
 * où on le lance, la seule fois où la question a du sens. Refusé ou déjà
 * accordé, le bouton se tait.
 */
export function NotifyMe() {
  const copy = useT().dashboard.notifyMe;
  const [permission, setPermission] = useState<Permission>(() =>
    notificationsSupported() ? Notification.permission : "unsupported",
  );

  if (permission === "unsupported" || permission === "denied") return null;
  if (permission === "granted") {
    return (
      <span className="inline-flex items-center gap-1.5 text-[12.5px] text-muted-foreground">
        <BellRing aria-hidden="true" className="size-3.5" /> {copy.enabled}
      </span>
    );
  }
  return (
    <Button
      onClick={() => {
        void Notification.requestPermission().then(setPermission);
      }}
      size="sm"
      type="button"
      variant="outline"
    >
      <Bell /> {copy.ask}
    </Button>
  );
}
